import { render, staticRenderFns } from "./PagePrintDetails.vue?vue&type=template&id=56c9f6a6"
import script from "./PagePrintDetails.vue?vue&type=script&lang=js"
export * from "./PagePrintDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports